import React from 'react'
import texts from '../../../common/texts.json'
import PropTypes from 'prop-types'
import './SiteToStoreTitle.css'

const SiteToStoreTitle = ({ isWalstore, isMobile }) => (
  <span className="site-to-store-title">
    {isWalstore || !isMobile
      ? texts.PRODUCT_DETAIL.STORE_SELECTOR_HEAD
      : texts.PRODUCT_DETAIL.CHOOSE_STORE_SELECTOR_HEAD}
  </span>
)

SiteToStoreTitle.defaultProps = {
  isWalstore: false,
  isMobile: false,
}

SiteToStoreTitle.propTypes = {
  isWalstore: PropTypes.bool,
  isMobile: PropTypes.bool,
}

export default SiteToStoreTitle
